import Head from 'next/head';
import React from 'react';
import PropTypes from 'prop-types';
import BaseLayout from 'layouts/BaseLayout';
import { COLOR_PURPLE_HOVER, COLOR_WHITE } from 'styles/variables/colors';
import useIsMobile from 'hooks/useIsMobile';

const Props = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]),
};

export default function CustomServiceLayout({ children }) {
  const isMobile = useIsMobile();

  return (
    <BaseLayout
      bgBrandColor={!isMobile ? COLOR_WHITE : COLOR_PURPLE_HOVER}
      headerWhite={true}
      typeBtn="buttonSecondary"
      hasPadding={false}
    >
      <Head>
        <title>Custom Services - Mind The Graph</title>
      </Head>

      {children}
    </BaseLayout>
  );
}

CustomServiceLayout.propTypes = Props;
